import { render, staticRenderFns } from "./practicalList.vue?vue&type=template&id=5a0a70ec&scoped=true"
import script from "./practicalList.vue?vue&type=script&lang=js"
export * from "./practicalList.vue?vue&type=script&lang=js"
import style0 from "./practicalList.vue?vue&type=style&index=0&id=5a0a70ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a70ec",
  null
  
)

export default component.exports